export default __webpack_public_path__ + "057b1f689a597f9a854abb58733c8ea9.png";